import React from 'react'

import { BodyText, HeadingXLarge, Button, Label } from '@pb/components'

import styles from './PendingMemberNotice.scss'

const PendingMemberNotice: React.FC<any> = ({ action }) => {
  return (
    <div className={styles.memberNotice}>
      <div className={styles.memberNoticeContent}>
        <HeadingXLarge className={styles.noticeHeading}>
          <Label copyKey="hub.custumer.pending.title" />
        </HeadingXLarge>
        <BodyText>
          <Label copyKey="hub.custumer.pending.message" />
        </BodyText>
      </div>

      <Button className={styles.memberNoticeAction} onClick={action}>
        <Label copyKey="hub.custumer.pending.button.retry" />
      </Button>
    </div>
  )
}

export default PendingMemberNotice
